import { useState, useEffect } from 'react';
import ModuleList from './module-list';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import TrainingModule from './training-module';
const StaffTraining = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [moduleSummary, setModuleSummary] = useState(null);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const fetchModules = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/training-modules`);

      if (response.status == 200) {
        setModules(response.data.modules);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const fetchModuleSummary = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/training-modules/summary`);

      if (response.status == 200) {
        setModuleSummary(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  useEffect(() => {
    if (selectedModule == null) {
      fetchModules();
      fetchModuleSummary();
    }
  }, [selectedModule]);

  return (
    <div className="p-6 space-y-6 lg:min-w-[78vw] lg:max-w-[80vw]">
      {!selectedModule ? (
        <>
          <ModuleList
            modules={modules}
            summary={moduleSummary}
            onSelect={setSelectedModule}
          />
        </>
      ) : (
        <TrainingModule
          module={selectedModule}
          onBack={() => setSelectedModule(null)}
        />
      )}
    </div>
  );
};

export default StaffTraining;
